import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ModalDebitoResumenComponent } from 'src/app/theme/components/modal-debito-resumen/modal-debito-resumen.component';

@Injectable({
  providedIn: 'root',
})
export class DialogServiceDebito{

  constructor(private dialog: MatDialog) { }
  dialogRef: MatDialogRef<ModalDebitoResumenComponent>;
  
  public open(options) {
    if(options){
      this.dialogRef = this.dialog.open(ModalDebitoResumenComponent, {   
        height: 'auto',
        width: '800px',
        panelClass: 'custom-dialog-debito-container',
        //panelClass: 'custom-sm-dialog-container',
        data: {
          icon: options.icon,//'info',
          title: options.title,
          content: options.content,
          bullet: options.bullet,
          bold: options.bold,
          confirmbtn: options.confirmbtn,
          cancelbtn: options.cancelbtn,
          cuerpo: options.cuerpo
      }});
    }
    
  }
  
  public confirmed(): Observable<any> {
    
    return this.dialogRef.afterClosed().pipe(take(1), map(res => {
        return res;
      }
    ));
  }

}
